import { FC, useState } from 'react'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { CommonProductComponent } from '../ComonProduct'
import { FixedTemplateItems } from '../ComonProduct/FixedTemplateItems'
import { KitchenInfoItemType } from '../types'
import { AddSpecialProductFooter } from '../footers/AddSpecialProductFooter'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

type AddCommonProductProps = {
  product: IProduct
  productTemplateId: ProductTemplateIdType
  onNext: (values: any) => void
}

export const AddMenuItemsProduct: FC<AddCommonProductProps> = ({
  product,
  productTemplateId,
  onNext,
}) => {
  // State
  const kitchenInfoState = useState<KitchenInfoItemType>({})

  return (
    <>
      <CommonProductComponent
        product={product}
        productTemplateId={productTemplateId}
        kitchenInfoState={kitchenInfoState}
        includedSlot={<FixedTemplateItems product={product} />}
      />
      <AddSpecialProductFooter
        product={product}
        moveToNext={() => onNext(kitchenInfoState[0])}
      />
    </>
  )
}
